/*------------------------------------*\
    SITE NAV
\*------------------------------------*/
class SiteNav {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        let triggers = document.querySelectorAll('[data-nav-trigger]');
        let overlay = document.querySelector('[data-nav-overlay]');
        let hamburgers = document.querySelectorAll('[data-hamburger]');

        triggers.forEach(trigger => {
            trigger.addEventListener('click', evt => {
                evt.preventDefault();
                self.elem.classList.toggle('is-open');
                overlay.classList.toggle('is-active');

                hamburgers.forEach(hamburger => {
                    hamburger.classList.toggle('is-active');
                });
            });
        });
    }
}

export default SiteNav;
